export function updateManipulation(workshop,state){
 const {screw,driver,driverHome}=workshop;
 const progress=Math.max(0,Math.min(1,Number.isFinite(state.screw)?state.screw:0));
 const angle=-progress*Math.PI*6;
 screw.rotation.z=angle;
 screw.position.copy(screw.userData.home);
 screw.position.z-=progress*screw.userData.travel;
 driver.scale.copy(driverHome.scale);
 if(['fasten','overload','leakage','complete'].includes(state.phase)){
  // Local +Y is the shaft axis; local origin is the actual flat blade endpoint.
  // R_x * R_y spins the blade around that shaft without moving the endpoint.
  driver.position.copy(screw.position);driver.position.z+=screw.userData.face;
  driver.rotation.set(Math.PI/2,angle,0,'XYZ');
  driver.visible=state.phase==='fasten';
 }else{
  driver.visible=true;driver.position.copy(driverHome.position);driver.rotation.copy(driverHome.rotation);
 }
}
